import { useHttpClient } from './httpClient.js';

const resource = 'sortition_displays';

export function fetchSortitionParams() {
	return useHttpClient().get(`/${resource}/params`);
}

export function createSortition(sortition) {
	const form = new FormData();

	form.append('logo', sortition.logo);
	form.append('background', sortition.background);
	form.append('name', sortition.name);
	form.append('schedules_attributes', JSON.stringify(sortition.schedules));
	form.append('order', sortition.order);
	form.append('sortitionId', sortition.sortitionId);
	form.append('result_fields', JSON.stringify(sortition.resultFields));
	form.append('lottery_id', sortition.lotteryId);
	form.append('server_ids', JSON.stringify(sortition.serverIds));
	return useHttpClient().post(`/${resource}`, form, {
		headers: { 'Content-Type': 'multipart/form-data' }
	});
}

export function fetchSortitions() {
	return useHttpClient().get(`/${resource}`);
}

export function fetchSortition(id) {
	return useHttpClient().get(`/${resource}/${id}`);
}

export function updateSortition(id, sortition) {
	const form = new FormData();

	form.append('id', id);
	form.append('logo', sortition.logo);
	form.append('background', sortition.background);
	form.append('name', sortition.name);
	form.append('schedules_attributes', JSON.stringify(sortition.schedules));
	form.append('order', sortition.order);
	form.append('sortitionId', sortition.sortitionId);
	form.append('result_fields', JSON.stringify(sortition.resultFields));
	form.append('lottery_id', sortition.lotteryId);
	form.append('server_ids', JSON.stringify(sortition.serverIds));
	return useHttpClient().put(`/${resource}/${id}`, form, {
		headers: { 'Content-Type': 'multipart/form-data' }
	});
}

export function destroySortition(id) {
	return useHttpClient().delete(`/${resource}/${id}`);
}
